import React, { PropsWithChildren } from 'react';
import { Tab } from 'react-bootstrap';

interface VerticalTabPaneProps {
  IsActive: boolean;
  Name: string;
}

const VerticalTabPane = (props: PropsWithChildren<VerticalTabPaneProps>) => {
  const { IsActive, Name, children } = props;
  return (
    <Tab.Pane active={IsActive}>
      <h2 className="h4 mb-32 fw-medium">{Name}</h2>
      {children}
    </Tab.Pane>
  );
};

export default VerticalTabPane;
export { VerticalTabPane };
export type { VerticalTabPaneProps };
